import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Ellipsis } from '@openx/components-core/lib/Ellipsis/Ellipsis';
import { HighlightedPhrase } from '@openx/components-core/lib/HighlightedPhrase/HighlightedPhrase';
import type { HierarchyItemWithLevels } from '@openx/types/hierarchyItem';

type OptionItemProps = {
  option: HierarchyItemWithLevels;
  searchPhrase: string;
};

export const OptionItem = ({ option, searchPhrase }: OptionItemProps) => {
  return (
    <Box
      sx={{
        paddingLeft: option.level * 2,
        width: '100%',
      }}
    >
      <Ellipsis width="100%" tooltip>
        <Typography sx={{ textWrap: 'wrap' }}>
          <HighlightedPhrase searchPhrase={searchPhrase}>{option.name}</HighlightedPhrase>
        </Typography>
      </Ellipsis>
    </Box>
  );
};
